export const openInAppHelp = () => {
  try {
    var _window$top;
    const openHelpWidget = (_window$top = window.top) === null || _window$top === void 0 || (_window$top = _window$top.hubspot) === null || _window$top === void 0 || (_window$top = _window$top.zorse) === null || _window$top === void 0 ? void 0 : _window$top.openHelpWidget;
    if (!openHelpWidget) {
      return false;
    }
    openHelpWidget();
    return true;
  } catch (_unused) {
    return false;
  }
};